import { isHaveItems } from '../store';
import { activeTags, globalSearch, groups, isShowSearchLoader, list, pagination, tags } from '../../../stores';
import { api } from '../../../../helpers';
import { get } from 'svelte/store';
import { tick } from 'svelte';
import { scrolledPublicationId } from '../../Newsline/store';
import { getTags } from "../../../custom/GlobalSearch/services/index.js";
import { getGroups } from "../../Newsline/services";
const setData = (data) => {
    list.set(data.results);
    pagination.set(data.pagination);
    isHaveItems.set(get(list).length !== 0);
    isShowSearchLoader.set(false);
};
export const infiniteScrollHandler = async () => {
    const { next_page_number } = get(pagination);
    const data = await getFavorites({ page: next_page_number });
    list.update((n) => [...n, ...data.results]);
    pagination.set(data.pagination);
    isShowSearchLoader.set(false);
};
export const addToFavorites = async (publicationId) => {
    await api(`/api/v1/favorite-publication/create/${publicationId}/`, 'POST');
};
export const deleteFromFavorites = async (publicationId) => {
    await api(`/api/v1/favorite-publication/delete/${publicationId}/`, 'DELETE');
};
export const getFavorites = async ({ page }) => {
    isShowSearchLoader.set(true);
    let path = `/api/v1/publication/favorite/list/?page=${page}`;
    const tags = get(activeTags);
    const searchByText = get(globalSearch);
    for (let tag of tags) {
        if (tags.length) {
            path += `&feed_tags=${tag}`;
        }
    }
    if (searchByText.length) {
        path += `&full_text_search=${get(globalSearch)}`;
    }
    const response = await api(path);
    const data = await response.json();
    return data;
};
export const search = async () => {
    list.set([]);
    setData(await getFavorites({ page: 1 }));
};
export const initFavorites = async () => {
    // resetSearch()
    if (!get(groups).length) {
        await getGroups();
    }
    if (!get(list).length) {
        setData(await getFavorites({ page: 1 }));
    }
    if (!get(tags).length) {
        await getTags();
    }
    await tick();
    const publication = document.getElementById(get(scrolledPublicationId));
    if (publication) {
        publication.scrollIntoView({ block: 'center' });
    }
};
